/**
 * Copyright 2023 SweetCode. All rights reserved.
 *
 * Load LinkedIn event listeners
 *
 * https://www.linkedin.com/help/lms/answer/a425606?lang=en-US
 *
 * */

// Pixel load event listener
jQuery(document).on("wpmLoadPixels", () => {

	if (wpmDataLayer?.pixels?.linkedin?.partner_id && !wpmDataLayer?.pixels?.linkedin?.loaded) {
		if (wpm.canIFire("ads", "linkedin")) wpm.load_linkedin_pixel()
	}
})

// view search event
jQuery(document).on("pmwEvent:Search", () => {

	try {
		if (!wpmDataLayer?.pixels?.linkedin?.loaded) return
		if (!wpmDataLayer?.pixels?.linkedin?.conversion_ids?.search) return

		window.lintrk("track", {
			conversion_id: wpmDataLayer.pixels.linkedin.conversion_ids.search,
		})
	} catch (e) {
		console.error(e)
	}
})

// view_content event
jQuery(document).on("wpmViewItem", (event, product = null) => {

	try {
		if (!wpmDataLayer?.pixels?.linkedin?.loaded) return
		if (!wpmDataLayer?.pixels?.linkedin?.conversion_ids?.view_content) return

		window.lintrk("track", {
			conversion_id: wpmDataLayer.pixels.linkedin.conversion_ids.view_content,
		})
	} catch (e) {
		console.error(e)
	}
})

// add_to_list event
jQuery(document).on("wpmAddToWishlist", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.linkedin?.loaded) return
		if (!wpmDataLayer?.pixels?.linkedin?.conversion_ids?.add_to_list) return

		window.lintrk("track", {
			conversion_id: wpmDataLayer.pixels.linkedin.conversion_ids.add_to_list,
		})
	} catch (e) {
		console.error(e)
	}
})

// add-to-cart event
jQuery(document).on("wpmAddToCart", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.linkedin?.loaded) return
		if (!wpmDataLayer?.pixels?.linkedin?.conversion_ids?.add_to_cart) return

		window.lintrk("track", {
			conversion_id: wpmDataLayer.pixels.linkedin.conversion_ids.add_to_cart,
		})
	} catch (e) {
		console.error(e)
	}
})


// start-checkout event
jQuery(document).on("wpmBeginCheckout", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.linkedin?.loaded) return
		if (!wpmDataLayer?.pixels?.linkedin?.conversion_ids?.start_checkout) return

		window.lintrk("track", {
			conversion_id: wpmDataLayer.pixels.linkedin.conversion_ids.start_checkout,
		})
	} catch (e) {
		console.error(e)
	}
})

// View order received page event
jQuery(document).on("wpmOrderReceivedPage", () => {

	try {
		if (!wpmDataLayer?.pixels?.linkedin?.loaded) return
		if (!wpmDataLayer?.pixels?.linkedin?.conversion_ids?.purchase) return

		window.lintrk("track", {
			conversion_id: wpmDataLayer.pixels.linkedin.conversion_ids.purchase,
		})

	} catch (e) {
		console.error(e)
	}
})

